import React, { useState, useEffect, useCallback } from 'react';
import { motion } from 'framer-motion';
import Select from "react-select";
import config from "../../config.js";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const MakeTrial = ({ onClose }) => {
    const [options, setOptions] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState({
        member: null,
        startDate: "",
        endDate: "",
        tool: ""
    });
    const [tools, setTools] = useState([]);

    const fetchUCDatas = useCallback(async () => {
        try {
            const response = await fetch(`${config.apiBaseUrl}/admin/gettools`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || 'Something went wrong');
            }

            if (Array.isArray(result.data) && result.data.length > 0) {
                setTools(result.data.map((usecase) => ({
                    name: usecase.label,
                    quantity: 0,
                    usecase_id: usecase.usecase_id,
                    selected: false
                })));
            } else {
                console.warn('No data found');
            }
        } catch (error) {
            console.error('Fetch error:', error.message);
        }
    }, []);

    const fetchMembersList = useCallback(async () => {
        try {
            const response = await fetch(`${config.apiBaseUrl}/admin/getmembers`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || 'Something went wrong');
            }

            if (Array.isArray(result.data) && result.data.length > 0) {
                setOptions(result.data.map((data) => ({
                    label: data.name,
                    velue: data.name,
                    client_id: data.client_id
                })));
            } else {
                console.warn('No data found');
            }
        } catch (error) {
            console.error('Fetch error:', error.message);
        }
    }, []);

    useEffect(() => {
        fetchMembersList();
        fetchUCDatas();
    }, [fetchUCDatas, fetchMembersList]);

    const handleChange = (key, value) => {
        setSelectedFilters(prev => ({ ...prev, [key]: value }));
    };

    const handleCheckboxChange = (index) => {
        const updatedTools = [...tools];
        updatedTools[index].selected = !updatedTools[index].selected;
        setTools(updatedTools);
    };

    const handleQuantityChange = (index, value) => {
        const updatedTools = [...tools];
        updatedTools[index].quantity = value;
        setTools(updatedTools);
    };

    const setTrialVersion = async () => {
        const filteredData = tools.filter(item => item.quantity > 0)
            .map(item => `"${item.usecase_id}":${item.quantity}`)
            .join(", ");

        const resData = `{${filteredData}}`;

        try {
            const response = await fetch(`${config.apiBaseUrl}/admin/setTrialMember`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    tool_camera: resData,
                    purchase_date: selectedFilters.startDate,
                    expiry_date: selectedFilters.endDate,
                    client_id: selectedFilters.member.client_id
                })
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || 'Something went wrong');
            }

            toast.info("Created successfully");
            setTimeout(() => { onClose(); }, 3000);

        } catch (error) {
            console.error('Fetch error:', error.message);
        }

    }

    return (
        <div className="popup-overlay">
             <ToastContainer />
            <motion.div
                className="popup-content maketrial-modalpopup"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.3, ease: "easeOut" }}
            >
                <div className='d-flex justify-content-between align-items-center header-content'>
                    <h5 className='mb-0 fw-bold'>Make free trial</h5>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        fill="currentColor"
                        onClick={onClose}
                        className="close-btn-tp"
                    >
                        <path d="M6 18L18 6M6 6l12 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className='popup-body-content'>
                    <label className="date-label-mt">Select Member</label>
                    <Select
                        options={options}
                        value={selectedFilters.member}
                        onChange={(val) => handleChange("member", val)}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Choose member..."
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#2d66ad" : "#ccc", // Blue border when focused
                                boxShadow: state.isFocused ? "0 0 0 2px rgba(0,123,255,0.25)" : "none",
                                "&:hover": { borderColor: "#2d66ad" }
                            }),
                            option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected ? "white" : state.isFocused ? "white" : "white",
                                color: "black"
                            })
                        }}
                    />

                    <div className="date-picker-container">
                        <label className="date-label-mt">Select Date</label>
                        <div className="date-range">
                            <input
                                type="date"
                                value={selectedFilters.startDate}
                                onChange={(e) => handleChange("startDate", e.target.value)}
                                className='date-input start-date-fm'
                            />
                            <span> - </span>
                            <input
                                type="date"
                                value={selectedFilters.endDate}
                                onChange={(e) => handleChange("endDate", e.target.value)}
                                className='date-input end-date-fm'
                            />
                        </div>
                    </div>
                    <div className='mt-3'>
                        <label className="date-label-mt">Select Usecases</label>
                        <div className='usecase-content'>
                            {tools.map((tool, index) => (
                                <div key={index} className="tool-row mb-2 d-flex align-items-center justify-content-between">
                                    <div className='d-flex align-items-center gap-2'>
                                        <input
                                            type="checkbox"
                                            checked={tool.selected}
                                            onChange={() => handleCheckboxChange(index)}
                                        />
                                        <label>{tool.name}</label>
                                    </div>

                                    <input
                                        type="number"
                                        min="0"
                                        style={{ maxWidth: "58px" }}
                                        value={tool.selected ? tool.quantity : "-"}
                                        disabled={!tool.selected}
                                        onChange={(e) => handleQuantityChange(index, parseInt(e.target.value))}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='mt-3 d-flex align-items-center justify-content-end gap-2'>
                        <button className='close-btn-mt com-btn-mt' onClick={onClose}>
                            Close
                        </button>
                        <button className='set-btn-mt com-btn-mt' onClick={setTrialVersion}>
                            Set
                        </button>
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

export default MakeTrial;
